module.exports = __webpack_public_path__ + "static/media/ee_slika.9b2c3057.png";